import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {StoryListComponent} from "./story-list/story-list.component";
import {LoginComponent} from "./login/login.component";

const routes: Routes = [
  {path: '', component: StoryListComponent},
  {path: 'login', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
